module.exports = __webpack_public_path__ + "img/mobile-rental-booking.daf0449d.svg";